import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

// Components
import Header from '../../components/Global/Header';
import Footer from '../../components/Global/Footer';
import AppCanvasLoader from '../../components/Global/AppCanvasLoader';
import CoachProfileViewsIndicator from '../../components/Global/CoachProfileViewsIndicator';
import LockedLink from '../../components/Global/LockedLink';

// Utils
import { isAdmin } from '../../utils/auth';

function ViewCoachButton(props) {
  return (
    <Link to={`/colleges/coaches/${props.coachId}`}>
      View Profile
    </Link>
  )
}

class CoachSearchResults extends Component {

  state = {
    isLoading: false,
    isAdmin: false,
    trialCanAccessResult: false,
    trial_info: {
      on_trial: null,
      trial_active: null,
      days_remaining: null,
      trial_expired: null,
      trial_coach_views: null,
    },
    trialViewsRemaining: 0,
  }

  componentDidMount() {
    const { user } = this.props;

    if (isAdmin(user)) {
      this.setState({ isAdmin: true })
    } else {
      this.setTrialInfo();
    }
  }

  setTrialInfo = () => {
    const { activeProfile } = this.props;
    const trialViewsRemaining = activeProfile.trial_info.trial_active ? activeProfile.trial_info.trial_coach_views : 0;

    this.setState({
      trialCanAccessResult: ( activeProfile.trial_info.trial_active && activeProfile.trial_info.trial_coach_views > 0 ),
      trialViewsRemaining,
      trial_info: activeProfile.trial_info,
    });
  }

  renderUserInitials = (coach) => {
    return `${coach.first_name.charAt(0)}${coach.last_name.charAt(0)}`;
  }

  returnSportGender(gender) {
    switch(gender) {
      case 'M':
        return "Men's";
        // eslint-disable-next-line no-unreachable
        break;
      case 'W':
        return "Women's";
        // eslint-disable-next-line no-unreachable
        break;
      case 'C':
        return "Coed";
        // eslint-disable-next-line no-unreachable
        break;
      default:
        return "";
        // eslint-disable-next-line no-unreachable
        break;
    }
  }

  render() {
    const {
      appName,
      location,
      path,
      user,
    } = this.props;

    const {
      isLoading,
      trialCanAccessResult,
      trialViewsRemaining,
      trial_info,
    } = this.state;

    const { isLoggedIn, reduxLogInComplete } = user;
    const coaches = location.state.coaches;
    const submission = location.state.submission;

    if (isLoggedIn && !reduxLogInComplete) {
      return <Redirect to={{ pathname: '/log-in' }}/>
    } else if (isLoggedIn && reduxLogInComplete) {
      return (
        <div>
          <Header path={ path } />
          {
            isLoading
            ? (
              <div className="dashboard-loader-container">
                <AppCanvasLoader />
              </div>
            )
            : (
              <div>
                { coaches.length === 0 ? (
                  <section className="coach-search coach-search-results content">
                    <div className="inner-wrap">
                      <div className="coach-search-header coach-search-header-empty">
                        <h4>{coaches.length} Coaches Found</h4>
                        <h2>We couldn't find any coaches matching your criteria.</h2>
                          <p>Search results for: &nbsp;
                            <span>{submission.college_name}</span>
                            <span>{this.returnSportGender(submission.gender)}</span>
                            <span>{decodeURIComponent(submission.sport)}</span>
                            <span>{submission.division}</span>
                            {submission.states.map((state) => (
                              <span>{state}</span>
                            ))}
                          </p>
                        <Link className="cta" to="/">Start a new search</Link>
                      </div>
                    </div>
                  </section>
                ) : (
                  <section className="coach-search coach-search-results content">
                    <div className="inner-wrap">
                      <div className="coach-search-header">
                        <h4>{coaches.length} Coaches Found</h4>
                        <h1>Coach Search Results</h1>
                        <p>Search results for: &nbsp;
                          <span>{submission.college_name}</span>
                          <span>{this.returnSportGender(submission.gender)}</span>
                          <span>{decodeURIComponent(submission.sport)}</span>
                          <span>{submission.division}</span>
                          {submission.states.map((state) => (
                            <span>{state}</span>
                          ))}
                        </p>
                        <Link className="cta" to="/">Start a new search</Link>
                      </div>
                        { trial_info.on_trial &&
                          <CoachProfileViewsIndicator remainingCoachProfileViews={trialViewsRemaining}/>
                        }
                    </div>
                    <div className="inner-wrap">
                      {coaches.map((coach, index) => (
                        <div className="search-result coach" key={index} >
                          <h5>{coach.school}</h5>
                          <div className="initial">
                            <div className="initial-inner">
                              {this.renderUserInitials(coach)}
                            </div>
                          </div>
                          <h3>{`${coach.first_name} ${coach.last_name}`}</h3>
                          <p>{coach.title}</p>
                          <div className="coach-profile-overview">
                            <h5>State</h5>
                            <p>{coach.state}</p>

                            <h5>Division</h5>
                            <p>{coach.division}</p>

                            <h5>Conference</h5>
                            <p>{coach.conference}</p>
                          </div>
                          { user.paid_content || trialCanAccessResult
                            ? (
                              <ViewCoachButton coachId={coach.coach_id} />
                            ) : (
                              <LockedLink />
                            )
                          }
                        </div>
                      ))}
                    </div>
                  </section>
                )}
                <Footer appName={ appName } path={ path } />
              </div>
            )
          }
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    activeProfile: state.activeProfile,
    user: state.user
  }
}

export default connect(
  mapStateToProps,
  null
)(CoachSearchResults)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/CoachSearchResults.js